import { render } from "./QRCODE.vue?vue&type=template&id=e12be550&scoped=true"
import script from "./QRCODE.vue?vue&type=script&lang=js"
export * from "./QRCODE.vue?vue&type=script&lang=js"

import "./QRCODE.vue?vue&type=style&index=0&id=e12be550&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/landing-page-telemedicina /node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e12be550"]])

export default __exports__